/* eslint-disable no-param-reassign */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = {
  master: [],
  systemConfiguration: [],
  blitzMasterConfiguration: {} as Record<string, string>,
  errors: null,
  persistError: null,
}
export const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {
    setMaster: (state, action: PayloadAction<any>) => {
      state.master = action.payload
    },
    setSystemConfiguration: (state, action: PayloadAction<string>) => {
      state.systemConfiguration = action.payload
    },
    setBlitzMasterConfiguration: (state, action: PayloadAction<Record<string, string>>) => {
      state.blitzMasterConfiguration = action.payload
    },
    setHookFormErrors: (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    },
    setHookFormPersistErrors: (state, action: PayloadAction<any>) => {
      state.persistError = action.payload
    },
    setContainerErrors: (state, action: PayloadAction<any>) => {
      state.containerErrors = action.payload
    },
  },
})
export const {
  setMaster,
  setSystemConfiguration,
  setBlitzMasterConfiguration,
  setHookFormErrors,
  setHookFormPersistErrors,
  setContainerErrors,
} = masterSlice.actions
export default masterSlice
const masterSelector = (state: any) => state.master
export const selectMasterData = createSelector(masterSelector, (state) => state.master)
export const selectSystemConfigurationData = createSelector(
  [masterSelector],
  (state) => state.systemConfiguration,
)
export const selectBlitzMasterConfigurationData = createSelector(
  [masterSelector],
  (state) => state.blitzMasterConfiguration,
)
export const selectHookFormErrors = createSelector(masterSelector, (state) => state.errors)
export const selectHookFormPersistErrors = createSelector(
  masterSelector,
  (state) => state.persistError,
)
export const selectContainerErrors = createSelector(
  masterSelector,
  (state) => state.containerErrors,
)
